import React from 'react'

import './pagination.scss'

import LeftIcon from '../../../assets/icons/arrow-left-wide.svg'
import RightIcon from '../../../assets/icons/arrow-right-wide.svg'

const methods = {
    buildPoints: (total, current) => {
        let pages = []
        if (total) {
            if (total <= 5) {
                let i
                for (i = 0; i < total; i++) {
                    pages.push({ pageNumber: i + 1, selected: false })
                }
                pages[current - 1].selected = true
            } else {
                pages.push({ pageNumber: 1, selected: false })
                pages.push({ pageNumber: total, selected: false })
                if (current === 2 && current !== total) {
                    pages.splice(1, 0, { pageNumber: current, selected: true }, {
                        pageNumber: current + 1,
                        selected: false
                    })
                } else if (current === total - 1 && current !== total) {
                    pages.splice(1, 0, { pageNumber: current - 1, selected: false }, {
                        pageNumber: current,
                        selected: true
                    })
                } else if (current !== 1 && current !== 2 && current !== total) {
                    pages.splice(1, 0, { pageNumber: current - 1, selected: false }, {
                        pageNumber: current,
                        selected: true
                    }, { pageNumber: current + 1, selected: false })
                } else {
                    if (current === 1) {
                        pages[0].selected = true
                        pages.splice(1, 0, { pageNumber: 2, selected: false }, { pageNumber: 3, selected: false })
                    } else {
                        pages[1].selected = true
                        pages.splice(1, 0, { pageNumber: total - 2, selected: false }, {
                            pageNumber: total - 1,
                            selected: false
                        })
                    }
                }
                if (current >= 4) {
                    pages[0].showPointsAfter = true
                }
                if (current <= total - 3) {
                    pages[pages.length - 1].showPointsBefore = true
                }
            }
        }
        return pages.sort((a, b) => {
            return a.pageNumber - b.pageNumber
        }).filter((item, pos, ary) => {
            return !pos || item.pageNumber !== ary[pos - 1].pageNumber
        })
    }
}

const Pagination = ({ handlePageChange, total, current }) => {
    const pages = methods.buildPoints(total, current)

    if (total > 1 && pages.length > 1) {
        return (
            <div className="pagination">
                <ul>
                    <li>
                        {current !== 1 &&
                            /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                            <a href="#" className="pagination-item-arrow"
                                onClick={() => handlePageChange(current - 1)}>
                                <span className="icon">
                                    <LeftIcon />
                                </span>
                            </a>
                        }
                    </li>
                    {pages.map((page) => <React.Fragment key={page.pageNumber}>
                        {page.showPointsBefore &&
                            <li><span className="pagination-item-dots">
                                …
                            </span></li>
                        }
                        <li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href="#" onClick={() => handlePageChange(page.pageNumber)}
                                className={page.selected ? "pagination-item-current" : "pagination-item-link"}>
                                {page.pageNumber}
                            </a>

                        </li>
                        {page.showPointsAfter &&
                            <li><span className="pagination-item-dots">
                                …
                            </span></li>
                        }
                    </React.Fragment>
                    )
                    }
                    <li>
                        {current !== total &&
                            /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                            <a href="#" className="pagination-item-arrow"
                                onClick={() => handlePageChange(current + 1)}>
                                <span className="icon">
                                    <RightIcon />
                                </span>
                            </a>
                        }
                    </li>
                </ul>
            </div>
        )
    } else {
        return null
    }
}

export default Pagination
